;(function ($) {

$(document).ready(function(){

    headerColorChange();

    $('.mobile-menu .menu-item-has-children').on('click',function(){
        $(this).toggleClass('open');
    });
    $('#desktop-burger-menu .menu-item-has-children').on('click',function(){
        $(this).toggleClass('open');
        $(this).find('.sub-menu').fadeToggle();
    });

    $('#mobile-menu').click(function(){
        $(this).toggleClass('open');

        $('.mobile-menu').fadeToggle();
        $('.utility-menu').fadeToggle();
    });
    $('#desktop-burger').click(function(){
        $(this).toggleClass('open');
        if ($(this).hasClass('open')) {
            $('#desktop-burger-menu').show("slide", { direction: "right" }, 500);
        } else {
            $('#desktop-burger-menu').hide("slide", { direction: "right" }, 500);
        }
    });

});


$(window).load(function(){


});


$(window).resize(function(){


});

/**
 * Optional Pinned Header
 */
$(window).scroll(function (event) {
    let scroll = $(window).scrollTop();
    let width = $(window).width();
    if(scroll > 84){
        $('header').addClass('scroll');
        if (width > 991) {
            $('.desktop-menus').hide();
            $('.desktop-hamburger').fadeIn();
        }
    } else {
        $('header').removeClass('scroll');
        if (width > 991) {
            $('.desktop-hamburger').hide();
            $('.desktop-menus').fadeIn();
        }
    }
});

//functions
function headerColorChange(){
    if ($('.hero').hasClass('bg-white') || $('.hero').hasClass('no-bkgd') || $('.single-team-container').hasClass('no-hero')) {
        $('header').addClass('dark');
        $('.utility-desktop, .nav-desktop').addClass('dark');
    }
}

})(jQuery);
